import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { User } from 'app/core/models';
import { TSIconModule, TsButtonModule, TsSnackbarService } from 'tsui';
import { Approval, ApprovalStatus } from '../../approvals.types';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-stakeholder-item',
  standalone: true,
  imports: [CommonModule, TSIconModule, TsButtonModule, MatTooltipModule],
  template: ` <div class="approval-row flex justify-between items-center mb-6">
    <div class="user">
      <div class="flex items-center space-x-3">
        <div class="w-8 h-8">
          <img class="rounded-full" src="https://gravatar.com/avatar/noavatar.png?d=mp" />
        </div>
        <div class="flex-1 text-left">
          <p class="text-lg">{{ approval.assigned_user.name }}</p>
        </div>
      </div>
    </div>
    <div class="actions flex items-center">
      @switch (approval.status) {
        @case (ApprovalStatus.APPROVED) {
          <div class="flex gap-1 text-green-500 mr-3">
            Approved
            <ts-icon [icon]="'check_circle'"></ts-icon>
          </div>
        }
        @case (ApprovalStatus.DECLINED) {
          <div class="flex gap-1 text-red-500 mr-3">
            Approval denied
            <ts-icon [icon]="'cancel'"></ts-icon>
          </div>
        }
        @case (ApprovalStatus.NOT_YET) {
          <div class="flex gap-1 text-black-400 mr-3">
            Awaiting approval
            <ts-icon [icon]="'check_circle_outline'"></ts-icon>
          </div>
        }
        @case (ApprovalStatus.NOT_SENT) {
          <div class="flex gap-1 text-black-400 mr-3">
            Request not sent
            <ts-icon [icon]="'check_circle_outline'"></ts-icon>
          </div>
        }
        @default {
          <div class="flex gap-1 text-black-400 mr-3">
            Request not sent
            <ts-icon [icon]="'check_circle_outline'"></ts-icon>
          </div>
        }
      }

      @if (showActionButton) {
        <ts-button
          (click)="resendApproval()"
          type="icon"
          icon="ts_refresh"
          [disabled]="resent"
          color="accent"
          matTooltip="Request Approval"
        ></ts-button>
      }

      @if (showActionButton && managementPermission) {
        <ts-button (click)="remove()" type="icon" icon="ts_trash-alt" color="accent" matTooltip="Remove"></ts-button>
      }
    </div>
  </div>`,
  styleUrls: ['./stakeholder-item.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StakeholderItemComponent {
  resent = false;

  @Input() approval: Approval;
  @Input() managementPermission = false;
  @Output() resendToApproval = new EventEmitter<Approval>();
  @Output() removeApproval = new EventEmitter<Approval>();
  ApprovalStatus = ApprovalStatus;
  constructor() {}

  get isDeclined(): boolean {
    return this.approval.status === ApprovalStatus.DECLINED;
  }

  get isPending(): boolean {
    return this.approval.status === ApprovalStatus.NOT_YET;
  }

  get notSent(): boolean {
    return this.approval.status === ApprovalStatus.NOT_SENT;
  }

  get showActionButton(): boolean {
    return this.isPending || this.isDeclined || this.notSent;
  }

  resendApproval(): void {
    this.resendToApproval.emit(this.approval);
    this.resent = true;
  }

  remove(): void {
    this.removeApproval.emit(this.approval);
  }
}
